export default store => store.availableRrcCoupons;
